function BlockDivider({marginTop}) {
	return (
        <div
			style={{
				width: '100%',
				height: `${10/360 * 100}vw`,
				backgroundColor: '#f2f2f2',
				marginTop: marginTop
			}}
		/>
	);
}

export default BlockDivider;
